import { Box, Text, HStack } from 'native-base';
import { BasicsTag } from '../basics-tag/basics-tag';

export interface VibeProps {
  text: string;
  icon?: string;
  size?: 'sm' | 'md';
  focused?: boolean;
}

export const Vibe = ({
  text,
  icon = undefined,
  size = 'md',
  focused = false,
}: VibeProps) => {
  return (
    <Box
      px={4}
      py={1.5}
      mb={2}
      backgroundColor={`rgba(0,0,0,0.15)`}
      borderColor={focused ? 'primary.200' : 'surface.300'}
      borderWidth={2}
      rounded={'full'}
    >
      <HStack space={2}>
        <Text fontSize={13}>{icon}</Text>
        <Text fontSize={13} color={focused ? 'primary.400' : 'white'}>
          {text.charAt(0).toUpperCase() + text.slice(1)}
        </Text>
      </HStack>
    </Box>
  );
};

export default Vibe;
